import * as React from 'react';

import firebase from "../firebase/firebase";



const ContactUser = (profile, uid) => new Promise(async (resolve, reject) => {
    const chatRef = firebase.firestore().collection('rooms');
    const messageRef = firebase.firestore().collection('messages');

   try {
     const getChat = await chatRef.where('participates', 'array-contains', uid).get()
     let isAlready = false;
     let chatId;
     let chat
     if (getChat.size > 0) {
         getChat.docs.forEach((d) => {
           const id = d.data().participates.find((d) => d === profile?.uid)
           if (id) {
             isAlready = true
             chatId = d.id
           }
         })
       }
       if (!isAlready) {
         chat = await chatRef.add({
           createdBy: profile.uid,
           participates: [profile.uid, uid],
           updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
           createdAt: firebase.firestore.FieldValue.serverTimestamp(),
           projectTitle: profile?.name,
           adminCreated: true
         })
           const message = await messageRef.add(
               {
                   text: `${profile?.userType === 'admin' && profile?.super ? 'super admin'.toUpperCase() : profile?.userType.toUpperCase()} ${profile?.name} created message!`,
                   type: 'created-message',
                   sender: profile?.uid,
                   receiver: uid,
                   createdAt:firebase.firestore.FieldValue.serverTimestamp(),
                   roomId: isAlready ? chatId :chat?.id,
                   read:false,
                   status: 'send'
               }
           )
           resolve(message.id)
       }else {
           chatRef.doc(chatId).update({
               updatedAt: firebase.firestore.FieldValue.serverTimestamp()
           }).then(() => resolve())

       }


   } catch (e) {
       reject()
   }
});
export default ContactUser;
